/** PURE_IMPORTS_START .._.._Observable,.._.._operator_scan PURE_IMPORTS_END */
import { Observable } from '../../Observable';
import { scan } from '../../operator/scan';
Observable.prototype.scan = scan;
//# sourceMappingURL=scan.js.map 



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/add/operator/scan.js
// module id = 709
// module chunks = 0